import { render, staticRenderFns } from "./podnikatel.vue?vue&type=template&id=fad4bd2c&"
import script from "./podnikatel.vue?vue&type=script&lang=js&"
export * from "./podnikatel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad4bd2c')) {
      api.createRecord('fad4bd2c', component.options)
    } else {
      api.reload('fad4bd2c', component.options)
    }
    module.hot.accept("./podnikatel.vue?vue&type=template&id=fad4bd2c&", function () {
      api.rerender('fad4bd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/podnikatel.vue"
export default component.exports